module.exports = __webpack_public_path__ + "assets/img/2q.49cf4853.png";